import React from 'react';

const JournalSection = () => {
  return (
    <div id="journal" className="text-left paddsection">
      <div className="container">
        <div className="section-title text-center">
          <h2>Insights & Articles</h2>
        </div>
      </div>
      <div className="container">
        <div className="journal-block">
          <div className="row">
            {/* Add journal items here */}
            <div className="col-lg-4 col-md-6">
              <div className="journal-info">
                <a href="https://medium.com/@jamesiukalu/cross-device-experience-in-ui-ux-frontend-development-creating-seamlessness-across-platforms-58b80f91d3c0" target='_blank' rel="noreferrer"><img src="assets/img/blog-post-1.jpg" className="img-responsive" alt="img" /></a>
                <div className="journal-txt">
                  <h4><a href="https://medium.com/@jamesiukalu/cross-device-experience-in-ui-ux-frontend-development-creating-seamlessness-across-platforms-58b80f91d3c0" target='_blank' rel="noreferrer">Cross-Device Experience in UI/UX Frontend Development</a></h4>
                  <p className="separator">Creating Seamlessness Across Platforms... <span className='float-end'>James Kalu</span></p>
                  <p class="post-details">
                  <span><a a href="https://medium.com/@jamesiukalu/cross-device-experience-in-ui-ux-frontend-development-creating-seamlessness-across-platforms-58b80f91d3c0" target='_blank' rel="noreferrer">3 min read</a><i class="bi bi-dot"></i>  Aug 25, 2023</span>
                </p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="journal-info">
                  <a href="/WebAccessibility"><img src="assets/img/blog-post-2.jpg" class="img-responsive" alt="img" /></a>
                  <div class="journal-txt">
  
                    <h4><a href="/WebAccessibility">2024 Web Accessibility Guide: 10 Must-Know Fundamentals</a></h4>
                    <p class="separator">Creating a website accessible to everyone is not just a good practice, it’s the right thing to do...<span className='float-end'>James Kalu</span>
                    </p>
  
                  </div>
  
                </div>
              </div>
  
              <div class="col-lg-4 col-md-6">
                <div class="journal-info">
  
                  <a href="/GoogleDev"><img src="assets/img/blog-post-3.jpg" class="img-responsive" alt="img" /></a>
  
                  <div class="journal-txt">
                    <h4><a href="/GoogleDev">Designing outside the Box : Exploring the path to Ui/Ux and harnessing your Design Potential to the Fullest</a></h4>
                    <p class="post-details">
                  <span><a href="/" className="inactive-link">Google Developer Student Clubs LASUSTECH</a><i class="bi bi-google"></i>  June 2, 2023</span>
                </p>
  
                  </div>
  
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JournalSection;
